// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ProfilePage_wrapper__2gdMv","content":"ProfilePage_content__38WYz","sidebar":"ProfilePage_sidebar__PgitU","mobileNavBar":"ProfilePage_mobileNavBar__3IRIV"};